
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^webpack_sharing_consume_default_(react\-(i18next_react\-i18next|router\-dom_react\-router\-dom)|clsx_clsx|date\-fns_date\-fns)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
